import { Badge, Box, Group, Stack, Text } from '@mantine/core';
import { getEnumColor, getEnumLabel } from '../../../../../utils/enumUtils';

import { CONVERSATION_TYPES } from '../../../../common/enums/enums';

const NameColumn = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const statusLabel = getEnumLabel(CONVERSATION_TYPES, rowData.type);
    const badgeColor = getEnumColor(CONVERSATION_TYPES, rowData.type);
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Group gap={'xs'}>
                    <Text>{rowData.name}</Text>
                    <Badge
                        color={badgeColor}
                        size={'xs'}>
                        {statusLabel}
                    </Badge>
                </Group>
                <Text>{rowData.dataset?.label}</Text>
            </Stack>
        </Box>
    );
};

const IdColumn = () => ({
    accessorKey: 'name',
    header: 'Name',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <NameColumn cell={cell} />,
});
export default IdColumn;
